import type { IOmit } from '@sixui/ui';
import type { NavigateProps } from 'react-router-dom';
import { Navigate as ReactRouterDomNavigate } from 'react-router-dom';

import { useOptionalAppRegion } from '~/hooks/useOptionalAppRegion';
import { getNavigationUrl } from './getNavigationUrl';

export type INavigateProps = IOmit<NavigateProps, 'to'> & {
  to: string;
};

export const Navigate: React.FC<INavigateProps> = (props) => {
  const { to, ...other } = props;
  const appRegion = useOptionalAppRegion();
  const url = getNavigationUrl(to, appRegion);

  return <ReactRouterDomNavigate {...other} to={url} />;
};
